const Client = () => import('../views/Client.vue')

export default [
  {
    path: 'entity/clients',
    component: Client,
    meta: { requiresAuth: true },
    name: 'clients'
  }
]